import refs from '../helpers/refs'

class CInputMultiText {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)
    this.tags = []

    this.init()
  }

  init () {
    // When enter is pressed in the fake input, add the tag, and clear the fake input
    this.$refs.fakeInput.addEventListener('keyup', (event) => {
      const value = event.target.value

      // Insert tag when... enter (13), comma (188), or 2 spaces have been entered (32 is space)
      if (event.keyCode === 13 || event.keyCode === 188 || (event.keyCode === 32 && value[value.length - 2] === ' ')) {
        this.addTag(value)
        event.target.value = ''
      } else if (this.tags.length > 0 && event.keyCode === 8 && value === '') {
        // If the user presses backspace, and the fake input is empty, remove the last tag
        const lastTag = this.$refs.fakeInput.previousElementSibling
        const lastTagValue = lastTag.getAttribute('data-option-value')

        this.removeTag(lastTagValue)
      }
    })

    this.$refs.fakeInput.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        event.preventDefault()
      }
    })

    // When focus leaves the fake input, add the tag, and clear the fake input
    this.$refs.fakeInput.addEventListener('blur', (event) => {
      const value = event.target.value

      if (value.trim() !== '') {
        this.addTag(value)
        event.target.value = ''
      }
    })
  }

  addTag (value) {
    const tagElem = document.createElement('div')

    value = value.replace(',', '').replace('  ', ' ').trim()

    tagElem.setAttribute('data-option-value', value)
    tagElem.classList = 'a-input-multi-text__tag h-8 mt-4 flex justify-center items-center text-white bg-grey-800 hover:bg-brand cursor-pointer'
    tagElem.innerHTML = `
      <p class="text-label-1 mt-1 ml-2">${value}</p>
      <div class="a-input-multi-text__remove-tag py-1 mr-1">
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          class="a-svg a-input-multi-text__tag-close fill-current text-white ml-2" role="img" width="18px" height="18px" viewBox="0 0 24 24">
            <path fill="#343738" d="M5.77 7.05l1.414-1.414 11.314 11.313-1.415 1.414z"></path>
            <path fill="#343738" d="M7.183 18.364L5.77 16.949 17.083 5.636l1.414 1.414z"></path>
        </svg>
      </div>
    `
    this.$refs.tagContainer.insertBefore(tagElem, this.$refs.fakeInput)

    tagElem.addEventListener('click', (event) => {
      event.stopPropagation()
      this.removeTag(value)
    })

    this.tags.push(value)
    this.$refs.realInput.value = this.tags.join(', ')
  }

  removeTag (value) {
    // Remove the tag
    const tag = this.$refs.tagContainer.querySelector(`.a-input-multi-text__tag[data-option-value="${value}"]`)
    this.$refs.tagContainer.removeChild(tag)

    this.tags.splice(this.tags.indexOf(value), 1)
    this.$refs.realInput.value = this.tags.join(', ')
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.a-input-multi-text')
    .forEach(el => new CInputMultiText(el))
})
